import react from 'react';
import LogoUE from "../media/logoUE.jpg";
import React from "react";

const FooterBar = () => {
    const url = window.location.href;

    if(url.split('/')[url.split('/').length - 1].includes('wycena')) return <></>
    return <div style={{width: "100%", position:"fixed", bottom: "0", background:"white", zIndex:"10"}}>
        <div style={{textAlign: "center", marginLeft: "100px", display: "flex", alignItems: "center"}}>
            Aplikacja została sfinansowana z programu pod nazwą „Inkubator Innowacyjności 4.0”
            finansowanego ze środków europejskich w ramach projektu pozakonkursowego „Wsparcie
            zarządzania badaniami naukowymi i komercjalizacja wyników prac B+R w jednostkach naukowych i
            przedsiębiorstwach”, realizowanego w ramach Programu Operacyjnego Inteligentny Rozwój 2014-
            2020.
            <img src={LogoUE} style={{width: "60%"}}/>
        </div>
    </div>
}

export default FooterBar;